export interface ResultFile {
  content_type: string;
  extension: string;
  filename: string;
  size: number;
  thumbnail: string;
  standard_extension: string;
}

export interface ResultRanking {
  assigned_rank: number;
  original_rank: number;
  relevance_score: number;
}

export interface Result {
  actions: string[];
  authors: any;
  category_url: string;
  category: string;
  comments: string[];
  companyconnector_name: string;
  companyconnector_parent_uuid: string;
  companyconnector_uuid: string;
  company_uuid: string;
  connector_name: string;
  content: string;
  favicon: string;
  files?: ResultFile[];
  images: string[];
  metadata: any;
  origin_unique_id: string;
  position: number;
  published_date: string;
  ranking: ResultRanking;
  result_id: string;
  search_id: string;
  source_position: number;
  subtitle: string;
  tags: string[];
  thumbnail: string;
  title: string;
  type_code: string;
  type: string;
  url: string | null | undefined;
  user_uuid: string;
  weight: number;
  showMore?: boolean;
  checked?: boolean;
  summaryStatus?:
    | 'extracting_content'
    | 'analysing_content'
    | 'summarizing_content'
    | 'summarized'
    | 'error_extracting_content'
    | 'error_summarizing_content';
  summary?: string;
  auto_summary: boolean;
  hash_string: string;
  selectedForBulkAction?: boolean;
}

export interface SearchResults {
  search_id: string;
  query: string | null;
  query_raw: string | null;
  mql_query: any | null;
  num_connectors: number | null;
  results: Result[];
  num_results: number | null;
  total_time: number | null;
  messages: any | null;
  results_indices: any | null;
  default_sort_method: string | null;
  sort_methods: string[];
  user_uuid: string | null;
  user_email: string | null;
  company_uuid: string | null;
}

export function initializeSearchResults(): SearchResults {
  return {
    search_id: '',
    query: null,
    query_raw: null,
    mql_query: null,
    num_connectors: null,
    results: [],
    num_results: null,
    total_time: null,
    messages: null,
    results_indices: null,
    default_sort_method: null,
    sort_methods: [],
    user_uuid: null,
    user_email: null,
    company_uuid: null,
  };
}
